import { EffectDeclare } from '@lib/model-proxy';

export const effects: { [key: string]: EffectDeclare } = {};
